import { Component, computed, inject, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { PrintOfficeService } from '../../../services/print-office.service';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-print-office-header',
  templateUrl: './print-office-header.component.html',
  styleUrls: ['./print-office-header.component.scss'],
  standalone: false,
})
export class PrintOfficeHeaderComponent implements OnInit {
  printOfficeService = inject(PrintOfficeService);
  authService = inject(AuthService);
  router = inject(Router);
  
  printOffices = toSignal(this.printOfficeService.getPrintOffices(), {
    initialValue: [],
  });

  printOfficeDto = computed(() => {
    return this.printOffices()?.find((x) => x.id === this.authService.printOfficeId());
  });

  constructor() {}

  ngOnInit() {}

  async goToSettings() {
    this.router.navigate(['/profile']);
  }
}
